'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const jsxRuntime = require('react/jsx-runtime');
const clsx = require('clsx');
const TableTd_module = require('../../../TableTd.module-By-eeaGx.js');

const TableTd = (props) => {
  return jsxRuntime.jsx("td", { className: clsx.clsx(TableTd_module.styles.tableTd, props.className), "data-freeze": props.freeze, "data-shadowed": props.shadowed, "data-zds": true, headers: props.headers, role: "cell", children: props.children });
};

exports.TableTd = TableTd;
//# sourceMappingURL=TableTd.cjs.js.map
